<template>
  <div class="contactdemo-container1">
    <app-navigation></app-navigation>
    <section id="demo-form-section" class="demo-form-section">
      <div class="demo-form-container2">
        <div class="form-column">
          <div class="form-panel">
            <h2 class="section-title">
              {{ $t("contactDemo.hero.title") }}
            </h2>
            <p class="section-content">
              {{ $t("contactDemo.hero.description") }}
            </p>
            <div id="form-banner" role="alert" aria-live="polite" class="contactdemo-thq-form-banner-elm form-banner"></div>
            <form id="demo-form" @submit.prevent="handleSubmit" class="demo-form2">
              <div class="form-row2">
                <div class="form-group2">
                  <label for="form-name" class="form-label">{{ $t("contactDemo.form.labels.name") }}</label>
                  <input type="text" id="form-name" name="form-name" required="true" v-model="form.name" class="form-input1" />
                  <span id="error-name" class="form-error">
                    {{ $t("contactDemo.form.errors.name") }}
                  </span>
                </div>
                <div class="form-group2">
                  <label for="form-company" class="form-label">{{ $t("contactDemo.form.labels.company") }}</label>
                  <input type="text" id="form-company" name="form-company" required="true" v-model="form.company" class="form-input1" />
                  <span id="error-company" class="form-error">
                    {{ $t("contactDemo.form.errors.company") }}
                  </span>
                </div>
              </div>
              <div class="form-row2">
                <div class="form-group2">
                  <label for="form-email" class="form-label">{{ $t("contactDemo.form.labels.email") }}</label>
                  <input type="email" id="form-email" name="form-email" required="true" v-model="form.email" class="form-input1" />
                  <span id="error-email" class="form-error">
                    {{ $t("contactDemo.form.errors.email") }}
                  </span>
                </div>
                <div class="form-group2">
                  <label for="form-phone" class="form-label">{{ $t("contactDemo.form.labels.phone") }}</label>
                  <input type="tel" id="form-phone" name="form-phone" required="true" v-model="form.phone" class="form-input1" />
                  <span id="error-phone" class="form-error">
                    {{ $t("contactDemo.form.errors.phone") }}
                  </span>
                </div>
              </div>
              <div class="form-row2">
                <div class="form-group2">
                  <label for="form-country" class="form-label">{{ $t("contactDemo.form.labels.country") }}</label>
                  <input type="text" id="form-country" name="form-country" required="true" v-model="form.country" class="form-input1" />
                  <span id="error-country" class="form-error">
                    {{ $t("contactDemo.form.errors.country") }}
                  </span>
                </div>
                <div class="form-group2">
                  <label for="form-city" class="form-label">{{ $t("contactDemo.form.labels.city") }}</label>
                  <input type="text" id="form-city" name="form-city" required="true" v-model="form.city" class="form-input1" />
                  <span id="error-city" class="form-error">
                    {{ $t("contactDemo.form.errors.city") }}
                  </span>
                </div>
              </div>
              <div class="form-group2 full-width">
                <label class="form-label">{{ $t("contactDemo.form.labels.machinesUsed") }}</label>
                <div class="checkbox-row">
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-router" name="machines" value="router" v-model="form.machine_router" />
                    <span>{{ $t("contactDemo.form.machines.router") }}</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-nesting" name="machines" value="nesting" v-model="form.machine_nesting" />
                    <span>{{ $t("contactDemo.form.machines.nesting") }}</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-saw" name="machines" value="panel-saw" v-model="form.machine_saw" />
                    <span>{{ $t("contactDemo.form.machines.panelSaw") }}</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-edgebander" name="machines" value="edgebander" v-model="form.machine_edgebander" />
                    <span>{{ $t("contactDemo.form.machines.edgebander") }}</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-other" name="machines" value="other" v-model="form.machine_other" />
                    <span>{{ $t("contactDemo.form.machines.other") }}</span>
                  </label>
                </div>
                <span id="error-machines" class="form-error">
                  {{ $t("contactDemo.form.errors.machines") }}
                </span>
              </div>
              <div class="full-width form-group2">
                <label for="form-role" class="form-label">{{ $t('contactDemo.form.labels.role') }}</label>
                <select id="form-role" name="form-role" v-model="form.role" data-form-field-id="form.role" class="form-input1">
                  <option value="interieurbouwer">{{ $t('contactDemo.form.labels.roleOptions[0]') }}</option>
                  <option value="machineleverancier">{{ $t('contactDemo.form.labels.roleOptions[1]') }}</option>
                  <option value="dealer">{{ $t('contactDemo.form.labels.roleOptions[2]') }}</option>
                  <option value="integrator">{{ $t('contactDemo.form.labels.roleOptions[3]') }}</option>
                  <option value="trainer">{{ $t('contactDemo.form.labels.roleOptions[4]') }}</option>
                </select>
              </div>
              <div class="form-row2">
                <div class="form-group2">
                  <label for="form-plate" class="form-label">{{ $t("contactDemo.form.labels.plate") }}</label>
                  <input type="text" id="form-plate" name="form-plate" required="true" v-model="form.plate" class="form-input1" />
                  <span id="error-plate" class="form-error">
                    {{ $t("contactDemo.form.errors.plate") }}
                  </span>
                </div>
                <div class="form-group2">
                  <label for="form-language" class="form-label">{{ $t("contactDemo.form.labels.language") }}</label>
                  <input type="text" id="form-language" name="form-language" required="true" v-model="form.language" class="form-input1" />
                  <span id="error-language" class="form-error">
                    {{ $t("contactDemo.form.errors.language") }}
                  </span>
                </div>
              </div>
              <div class="full-width form-group2">
                <label for="form-interest" class="form-label">{{ $t('contactDemo.form.labels.interest') }}</label>
                <select id="form-interest" name="form-interest" v-model="form.interest" data-form-field-id="form.interest" class="form-input1">
                  <option value="software">{{ $t('contactDemo.form.labels.interestOptions[0]') }}</option>
                  <option value="partner">{{ $t('contactDemo.form.labels.interestOptions[1]') }}</option>
                </select>
              </div>
              <button name="button vn4pfnax1" type="submit" class="btn form-submit-btn btn-primary">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11zm7.318-19.539l-10.94 10.939"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t("contactDemo.form.actions.send") }}</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";

import AppNavigation from "../components/navigationMini";
import AppFooter from "../components/footerMini";
import axios from "axios";

export default {
  name: "Contactdemo",
  props: {},
  components: { AppNavigation, AppFooter },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: "Contactdemo - KORPUS by VLECAD®",
      meta: [
        {
          name: "description",
          content:
            "KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.",
        },
        {
          property: "og:title",
          content: "Contactdemo - KORPUS by VLECAD®",
        },
        {
          property: "og:description",
          content:
            "KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.",
        },
        {
          property: "og:image",
          content:
            "https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://hospitable-imperfect-heron-qlicxu.teleporthq.app/contactdemo",
        },
      ],
    });
  },
  data() {
    return {
      baseURL: "https://my.vlecad.be/",
      form: {
        name: "",
        email: "",
        company: "",
        phone: "",
        country: "",
        city: "",
        role: "",
        plate: "",
        language: "",
        interest: "",
        machine_router: false,
        machine_nesting: false,
        machine_saw: false,
        machine_edgebander: false,
        machine_other: false,
      },
    };
  },
  methods: {
    handleSubmit() {
      console.log("handleSubmit called");
      console.log("form: " + JSON.stringify(this.form));

      axios
        .post(this.baseURL + "api/mail/sendMailAutofitMini.php", this.form)
        .then((res) => {
          console.log(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log("error sendMailAutofitMini: " + err);
        });

      console.log("Formulier verzonden:", this.form);
      alert(this.$t('common.thanks'));

      return false; // Zorgt ervoor dat de pagina niet opnieuw wordt geladen
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
@keyframes heroFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes heroCtaSlide {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes heroCardFade {
  from {
    opacity: 0;
    transform: translateX(12px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes ctaPanelFade {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes bannerSlide {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes integrationsFade {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes contactSlide {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes testimonialFade {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
*:focus-visible {
  outline: 2px solid var(--color-outline);
  outline-offset: 2px;
}
* {
  transition: background-color var(--animation-duration-fast) var(--animation-curve-primary),
    color var(--animation-duration-fast) var(--animation-curve-primary), border-color var(--animation-duration-fast) var(--animation-curve-primary);
}
*:where(:not(:active):not(:focus):not(:hover)) {
  transition-duration: var(--animation-duration-standard);
}
</style>

<style scoped>
.contactdemo-container1 {
  width: 100%;
  display: block;
  min-height: 100vh;
}

.contactdemo-container2 {
  display: none;
}

.contactdemo-container3 {
  display: contents;
}

.contactdemo-container4 {
  display: none;
}

.contactdemo-container5 {
  display: contents;
}

.contactdemo-container6 {
  display: none;
}

.contactdemo-container7 {
  display: contents;
}

.contactdemo-thq-form-banner-elm {
  display: none;
}
</style>
